import React from 'react';
import * as S from './styles';

type Props = {
  onClick: () => void;
  text: string;
  selected: boolean;
  index: number;
  logo?: string;
};

export default ({ logo, onClick, text, selected, index }: Props) => {
  return (
    <S.Item
      onClick={onClick}
      selected={selected}
      style={{ order: index }}
      data-test="SearchSuggestionItem"
    >
      <S.RowInfo>
        <S.IconWrapper>{logo && <S.Icon storeLogo src={logo} />}</S.IconWrapper>
        {text}
      </S.RowInfo>
    </S.Item>
  );
};
